import React, { useState, useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import { Redirect } from "react-router-dom";
import theme from "../../theme";
import CommonTable from "../table";
import CommonButton from "../button";
import { getCountriesFeesListAction, getVendorFeesAction, createVendorFeesAction, updateVendorFeesAction, deleteVendorFeesAction } from "../../containers/dashboard/action";
import Loading from "../loading";
import FormModal from "./modal";
import ShopFeesModal from "./ShopFeesModal";
import {
  getCountriesAction,
  getCurrenciesAction,
} from "../../containers/login/action";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.colors.White,
    width: "100%",
    minHeight: "calc(100vh - 175px)",
    padding: "45px 90px",
    marginLeft: "220px",
  },
  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .title": {
      color: theme.colors.Violet,
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      fontSize: "24px",
    },
  },
  headerName: {
    fontSize: "13px",
    fontFamily: theme.fontFamily.MARKPROHEAVY,
    opacity: "0.3",
    color: theme.colors.Violet,
  },
  Tab: {
    position: "relative",
    top: "10px",
    left: "-22px",
    cursor: "pointer",
    "& .tableTitle": {
      borderRadius: "10px 10px 0px 0px",
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      fontSize: "16px",
      color: theme.colors.DodgerBlue,
      cursor: "pointer",
      padding: "15px 25px",
      top: `50%`,
      left: `15%`,
      transform: `translate(-50%,-50%)`,
      position: "absolute",
    },
  },
  tableContainer: {
    marginTop: "30px",
  },
  tableHeader: {
    color: theme.colors.Violet,
    fontFamily: theme.fontFamily.MARKPROMEDIUM,
    fontSize: "20px",
    marginBottom: "15px",
    marginTop: "40px",
  },
  listContainer: {
    marginTop: "30px",
    "& .block": {
      cursor: "pointer",
      background: theme.colors.White,
      boxShadow: "0px 2px 15px #D0CFDB99",
      borderRadius: "15px",
      padding: "15px 30px",
      display: "flex",
      marginBottom: "15px",
      alignItems: "center",
      justifyContent: "space-between",
      "& .left": {
        flex: "0.7",
        display: "flex",
        alignItems: "center",
        "& .countryInfoContainer": {
          marginLeft: "25px",
          color: theme.colors.Violet,
          "& .countryName": {
            fontSize: "22px",
            fontFamily: theme.fontFamily.MARKPROBOLD,
            marginBottom: "10px",
          },
          "& .countryCurrencies": {
            fontSize: "14px",
            fontFamily: theme.fontFamily.MARKPRO,
            color: theme.colors.DodgerBlue,
          },
        },
      },
      "& .right": {
        flex: "0.3",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      },
    },
  },
  currency: {
    fontSize: "8px",
    position: "relative",
    bottom: "3px",
    marginRight: "2px",
  },
  successTube: {
    color: "#22D559",
    fontSize: "10px",
    fontFamily: theme.fontFamily.MARKPROBOLD,
    borderRadius: "14px",
    backgroundColor: "#E4FDEC",
    textAlign: "center",
    padding: "2px 8px",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
  },
  editLabel: {
    cursor: "pointer",
    color: theme.colors.DodgerBlue,
    marginRight: "10px",
    fontFamily: theme.fontFamily.MARKPROHEAVY,
    display: "flex",
    alignItems: "center",
  },
  deleteLabel: {
    cursor: "pointer",
    color: theme.colors.Pomegranate,
    fontFamily: theme.fontFamily.MARKPROHEAVY,
  },
  wrapIcon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

// let data = [
//   {
//     id: "CA",
//     name: "Canada",
//     currency: ["canadian dollar", "dollar"],
//   },
//   {
//     id: "AE",
//     name: "United Arab Emirates",
//     currency: ["UAE Dirham"],
//   },
//   {
//     id: "CU",
//     name: "Cuban",
//     currency: ["Cuban Peso"],
//   },
//   {
//     id: "PH",
//     name: "Phillipines",
//     currency: ["phillipines peso"],
//   },
// ];
function Countries() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const getCountriesListMethod = useCallback(
    (data) => dispatch(getCountriesFeesListAction(data)),
    [dispatch]
  );

  const dashboardReducer = useSelector((state) => {
    return state.dashboardReducer;
  });

  const loginReducer = useSelector((state) => {
    return state.loginReducer;
  });

  const [openModal, setOpenModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [openShopFeesModal, setOpenShopFeesModal] = useState(false);
  const [editShopFeesData, setEditShopFeesData] = useState(null);
  const prevCreateVendorFeesSuccessRef = useRef(false);
  const prevUpdateVendorFeesSuccessRef = useRef(false);
  const prevDeleteVendorFeesSuccessRef = useRef(false);
  const [groupedCountryFeesList, setGrouedCountryFeesList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [vendorFeesPage, setVendorFeesPage] = useState(1);
  const [vendorFeesTotalPage, setVendorFeesTotalPage] = useState(1);
  const page_size = 10;

  const getCountriesMethod = useCallback(
    () => dispatch(getCountriesAction()),
    [dispatch]
  );
  const getCurrenciesMethod = useCallback(
    () => dispatch(getCurrenciesAction()),
    [dispatch]
  );

  const getVendorFeesMethod = useCallback(
    (data) => dispatch(getVendorFeesAction(data)),
    [dispatch]
  );

  const createVendorFeesMethod = useCallback(
    (data) => dispatch(createVendorFeesAction(data)),
    [dispatch]
  );

  const updateVendorFeesMethod = useCallback(
    (data) => dispatch(updateVendorFeesAction(data)),
    [dispatch]
  );

  const deleteVendorFeesMethod = useCallback(
    (fee_range_id) => dispatch(deleteVendorFeesAction(fee_range_id)),
    [dispatch]
  );

  useEffect(() => {
    if (!openModal && !openShopFeesModal) {
      getCountriesListMethod({ page, page_size });
      getCountriesMethod();
      getCurrenciesMethod();
      getVendorFeesMethod({ page: vendorFeesPage, page_size });
    }
  }, [
    openModal,
    openShopFeesModal,
    getCountriesMethod,
    getCurrenciesMethod,
    getCountriesListMethod,
    getVendorFeesMethod,
    page,
    page_size,
    vendorFeesPage,
  ]);

  useEffect(() => {
    const {
      countryFeesList,
      createCountryFeesSuccess,
      updateCountryFeesSuccess,
      vendorFees,
      createVendorFeesSuccess,
      updateVendorFeesSuccess,
      deleteVendorFeesSuccess,
    } = dashboardReducer;
    if (createCountryFeesSuccess || updateCountryFeesSuccess) {
      getCountriesListMethod({ page, page_size });
    }

    // Handle vendor fees success states with ref to prevent loops
    const currentCreateSuccess = !!createVendorFeesSuccess;
    const currentUpdateSuccess = !!updateVendorFeesSuccess;
    const currentDeleteSuccess = !!deleteVendorFeesSuccess;

    if (currentCreateSuccess && !prevCreateVendorFeesSuccessRef.current) {
      prevCreateVendorFeesSuccessRef.current = true;
      getVendorFeesMethod({ page: vendorFeesPage, page_size });
    } else if (!currentCreateSuccess) {
      prevCreateVendorFeesSuccessRef.current = false;
    }

    if (currentUpdateSuccess && !prevUpdateVendorFeesSuccessRef.current) {
      prevUpdateVendorFeesSuccessRef.current = true;
      getVendorFeesMethod({ page: vendorFeesPage, page_size });
    } else if (!currentUpdateSuccess) {
      prevUpdateVendorFeesSuccessRef.current = false;
    }

    if (currentDeleteSuccess && !prevDeleteVendorFeesSuccessRef.current) {
      prevDeleteVendorFeesSuccessRef.current = true;
      getVendorFeesMethod({ page: vendorFeesPage, page_size });
    } else if (!currentDeleteSuccess) {
      prevDeleteVendorFeesSuccessRef.current = false;
    }

    if (countryFeesList?.count) {
      setTotalPage(Math.ceil(countryFeesList.count / page_size));
    }
    if (vendorFees?.count) {
      setVendorFeesTotalPage(Math.ceil(vendorFees.count / page_size));
    } else if (Array.isArray(vendorFees) && vendorFees.length) {
      // If history=true is used, it returns a list directly
      setVendorFeesTotalPage(1);
    }
  }, [dashboardReducer, page, page_size, vendorFeesPage, getCountriesListMethod, getVendorFeesMethod]);

  useEffect(() => {
    getVendorFeesMethod({ page: vendorFeesPage, page_size });
  }, [dashboardReducer?.deleteVendorFeesError, dashboardReducer?.deleteVendorFeesSuccess]);

  useEffect(() => {
    if (
      dashboardReducer?.error?.length ||
      dashboardReducer?.deleteDeductionError?.length
    ) {
      const ele = document.getElementsByClassName("error-container");
      if (ele && ele.length) ele[0].scrollIntoView(false);
    } else if (dashboardReducer?.countryFeesList?.data?.length) {
      let countryFees = dashboardReducer?.countryFeesList?.data;
      let countryNameFees = countryFees.map((fees) => {
        // eslint-disable-next-line
        let country = loginReducer?.countryOptions?.find((item) => {
          if (item.id === fees.country) {
            return true;
          }
        });
        return { ...fees, countryName: country?.name };
      });
      let groupedCountryFeesList = groupBy(countryNameFees, "country");
      let list = [];
      for (const key in groupedCountryFeesList) {
        // let obj = {};
        // key = groupedCountryFeesList[key];
        list.push({ key: groupedCountryFeesList[key] });
      }
      setGrouedCountryFeesList(list);
    }
  }, [dashboardReducer, loginReducer]);

  const groupBy = (items, key) =>
    items.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {}
    );
  return JSON.parse(localStorage.getItem("user"))?.is_super ? (
    <div className={classes.root}>
      {/* <Loading
        showLoader={dashboardReducer?.loading || loginReducer?.loading}
      /> */}
      <div className={classes.headerContainer}>
        <div className="title">Countries</div>
        <div>
          <CommonButton
            type="button"
            text={"Set Up Country"}
            stylevariant="secondary4"
            onClick={() => {
              setOpenModal(true);
              setEditData(null);
            }}
            style={{ padding: "5px 40px" }}
            fontSize="18px"
            fontFamily={theme.fontFamily.MARKPROHEAVY}
          />
        </div>
      </div>
      {!openModal && dashboardReducer?.error?.length ? (
        <div className={"error-container"}>
          {dashboardReducer.error.map((each, index) => (
            <div key={index}>{each}</div>
          ))}
        </div>
      ) : !openModal && dashboardReducer?.deleteDeductionError?.length ? (
        <div className={"error-container"}>
          {dashboardReducer.deleteDeductionError.map((each, index) => (
            <div key={index}>{each}</div>
          ))}
        </div>
      ) : null}
      {!dashboardReducer?.loading ? (
        <>
          <div className={classes.tableContainer}>
            <CommonTable
              columns={[
                {
                  Header: "Name",
                  accessor: "key",
                  HeaderCell: (data) => {
                    return <div className={classes.headerName}>{data}</div>;
                  },
                  Cell: (data) => {
                    return <span>{data[0].countryName}</span>;
                  },
                },
                {
                  Header: "Currencies",
                  accessor: "key",
                  HeaderCell: (data) => {
                    return <div className={classes.headerName}>{data}</div>;
                  },
                  Cell: (data) => {
                    let currencies = [];
                    data.forEach((el) => {
                      currencies.push(el.currency);
                    });
                    let element = currencies.join(",");
                    return <span>{element}</span>;
                  },
                },
                {
                  Header: "",
                  accessor: "key",
                  HeaderCell: (data) => {
                    return <div className={classes.headerName}>{data}</div>;
                  },
                  Cell: (data) => {
                    return (
                      <div
                        className={classes.editLabel}
                        onClick={() => {
                          setOpenModal(true);
                          setEditData(data);
                        }}
                      >
                        <img
                          src={"/images/editIcon.svg"}
                          style={{ marginRight: "8px", marginBottom: "3px" }}
                          alt="icon"
                        />{" "}
                        Edit Country
                      </div>
                    );
                  },
                },
              ]}
              data={groupedCountryFeesList}
            />

            {dashboardReducer?.countryFeesList?.data?.length ? (
              <div className={"pagination"}>
                <Pagination
                  page={page}
                  count={totalPage}
                  showFirstButton
                  showLastButton
                  onChange={(event, value) => {
                    setPage(value);
                  }}
                />
              </div>
            ) : null}
          </div>

          {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "40px", marginBottom: "15px" }}>
            <div className={classes.tableHeader}>Shop Fees</div>
            <div>
              <CommonButton
                type="button"
                text={"Set Up Shop Fees"}
                stylevariant="secondary4"
                onClick={() => {
                  setOpenShopFeesModal(true);
                  setEditShopFeesData(null);
                }}
                style={{ padding: "5px 40px" }}
                fontSize="18px"
                fontFamily={theme.fontFamily.MARKPROHEAVY}
              />
            </div>
          </div>
          <div className={classes.tableContainer}>
            <CommonTable
              columns={[
                {
                  Header: "Start Range",
                  accessor: "start_range",
                  HeaderCell: (data) => {

                    return <div className={classes.headerName}>{data}</div>;
                  },
                  Cell: (data) => {
                    console.log(data)
                    return <span>{data || "0"}</span>;
                  },
                },
                {
                  Header: "End Range",
                  accessor: "end_range",
                  HeaderCell: (data) => {
                    return <div className={classes.headerName}>{data}</div>;
                  },
                  Cell: (data) => {
                    return <span>{data || "0"}</span>;
                  },
                },
                {
                  Header: "Fee",
                  accessor: "fee",
                  HeaderCell: (data) => {
                    return <div className={classes.headerName}>{data}</div>;
                  },
                  Cell: (data) => {
                    return <span>{data || "0"}</span>;
                  },
                },
                {
                  Header: "Country",
                  accessor: "country",
                  HeaderCell: (data) => {
                    return <div className={classes.headerName}>{data}</div>;
                  },
                  Cell: (data) => {
                    const country = loginReducer?.countryOptions?.find(
                      (item) => item.id === data
                    );
                    return <span>{country?.name || data || "N/A"}</span>;
                  },
                },
                {
                  Header: "",
                  accessor: "id",
                  HeaderCell: (data) => {
                    return <div className={classes.headerName}>{data}</div>;
                  },
                  Cell: (data, row) => {
                    return (
                      <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                        <div
                          className={classes.editLabel}
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenShopFeesModal(true);
                            setEditShopFeesData(row);
                          }}
                        >
                          <img
                            src={"/images/editIcon.svg"}
                            style={{ marginRight: "8px", marginBottom: "3px" }}
                            alt="icon"
                          />{" "}
                          Edit Shop Fees
                        </div>
                        <div
                          className={classes.deleteLabel}
                          onClick={(e) => {
                            e.stopPropagation();

                            deleteVendorFeesMethod(row.id);

                          }}
                        >
                          Remove
                        </div>
                      </div>
                    );
                  },
                },
              ]}
              data={
                Array.isArray(dashboardReducer?.vendorFees)
                  ? dashboardReducer.vendorFees
                  : dashboardReducer?.vendorFees?.data || []
              }
              loading={dashboardReducer?.loading}
            />

            {(Array.isArray(dashboardReducer?.vendorFees) && dashboardReducer.vendorFees.length) ||
              dashboardReducer?.vendorFees?.data?.length ? (
              <div className={"pagination"}>
                <Pagination
                  page={vendorFeesPage}
                  count={vendorFeesTotalPage}
                  showFirstButton
                  showLastButton
                  onChange={(event, value) => {
                    setVendorFeesPage(value);
                  }}
                />
              </div>
            ) : null}
          </div> */}
        </>
      ) : null}
      <FormModal
        openModal={openModal}
        editData={editData}
        onClose={() => {
          setOpenModal(false);
          setEditData(null);
        }}
      />
      <ShopFeesModal
        openModal={openShopFeesModal}
        editData={editShopFeesData}
        onClose={() => {
          setOpenShopFeesModal(false);
          setEditShopFeesData(null);
        }}
      />
    </div>
  ) : (
    <Redirect to="/" />
  );
}

export default Countries;
